import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { PhoneIcon, SmartphoneIcon, BuildingIcon } from 'lucide-react';
export function ContactCTA() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const contacts = [{
    icon: SmartphoneIcon,
    label: 'Cell',
    number: '(240) 535-8731'
  }, {
    icon: PhoneIcon,
    label: 'Office',
    number: '(800) 579-0970'
  }, {
    icon: BuildingIcon,
    label: 'Office 2',
    number: '(301) 586-4767'
  }];
  return <section className="py-16 bg-light-alt border-y border-gray-100" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-44">
        <div ref={ref} className={`bg-white rounded-2xl shadow-xl overflow-hidden transition-all duration-1000 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-45">
          <div className="grid grid-cols-1 lg:grid-cols-3" data-id="element-46">
            {/* Left side text */}
            <div className="bg-primary p-10 lg:p-12 text-white flex flex-col justify-center" data-id="element-47">
              <h2 className="text-3xl font-bold mb-4" data-id="element-48">Get in Touch</h2>
              <p className="text-primary-light text-lg mb-0 text-white/90" data-id="element-49">
                We're here to help. Reach out to us anytime to discuss your care
                needs or schedule a consultation.
              </p>
            </div>

            {/* Right side contacts */}
            <div className="col-span-2 p-10 lg:p-12 grid grid-cols-1 sm:grid-cols-3 gap-8 items-center" data-id="element-50">
              {contacts.map((contact, idx) => <a key={idx} href={`tel:${contact.number.replace(/\D/g, '')}`} className="flex flex-col items-center text-center group p-4 rounded-xl hover:bg-light-alt transition-colors" data-id="element-51">
                  <div className="bg-primary/10 p-4 rounded-full mb-4 group-hover:bg-primary group-hover:text-white text-primary transition-colors duration-300" data-id="element-52">
                    <contact.icon className="h-8 w-8" data-id="element-53" />
                  </div>
                  <span className="text-sm font-semibold text-dark-muted uppercase tracking-wider mb-1" data-id="element-54">
                    {contact.label}
                  </span>
                  <span className="text-xl font-bold text-dark group-hover:text-primary transition-colors" data-id="element-55">
                    {contact.number}
                  </span>
                </a>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}